<template>
  <loader v-if="loading"/>
  <div v-else id="discount-lading">
    <div class="discount-message">
      <div v-if="isSuccess">
        <img class="success-icon" :src="require('@/assets/discount-riseup-friends.svg')">
        <div class="message-title">מעולה, חשבון דיסקונט חובר בהצלחה!</div>
        <div class="message-text">
          <span>הנתונים בבדיקה,</span>
          <span class="bold">הבוט של riseup   🤖
יעדכן אותך ב-WhatsApp</span><span> על המשך
התהליך.</span>
        </div>
      </div>
      <div v-else>
        <div v-if="isKnownError">
          <alert-page emoji="☝️" title="תהליך ההתחברות לדיסקונט לא הסתיים.">
            <template v-slot:content>
              אפשר לחזור לתהליך ההרשמה דרך הלינק שמופיע לך ב-WhatsApp.
              <div class="bold new-line">ניסית לחבר חשבון שותפים? 👫</div>
              לאחר החתימה על הטפסים והקמת הרשאה בבנק, תגיע אליך הודעת sms להשלמת החיבור.
            </template>
          </alert-page>
        </div>
        <div v-else>
          <alert-page emoji="🛠" title="אופס, יש תקלה והחיבור לא הצליח">
            <template v-slot:content>
              אפשר לנסות להתחבר שוב דרך הלינק שמופיע בWhatsapp. אם התקלה חוזרת, הצוות שלנו זמין בצ'אט וישמח לעזור.
            </template>
          </alert-page>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import DiscountApi from '../../../../api/DiscountApi';
import DDLogs from '../../../../DDLogs';
import Segment from '../../../../Segment';
import AlertPage from '../../../../base-components/AlertPage.vue';
import Loader from '../../../../base-components/Loader.vue';
import router from '../../../../router';

export default {
  name: 'DiscountLandingPage',
  components: {
    AlertPage,
    Loader,
  },
  data() {
    return {
      loading: false,
      isSuccess: true,
      isKnownError: false,
      syncOnboarding: false,
    };
  },
  async created() {
    this.loading = true;
    await this.fetchOnboardingState();
    this.syncOnboarding = !!this.pageName;
    const accessCode = this.$route.query.code;
    const { state, error, refreshed } = this.$route.query;
    if (error === 'access_denied') {
      // User didn't approve permissions. Maybe be deliberate or part of joint flow.
      Segment.trackUserGot('DiscountLandingPage_AccessDenied');
      DDLogs.log('User redirected from discount with access denied error.' +
        'This may be deliberate or part of joint flow', { query: this.$route.query });
      this.isSuccess = false;
      this.isKnownError = true;
      if (this.isNewOnboarding) {
        this.redirectToNewOnboarding();
      }
      this.loading = false;
    } else if (error || !accessCode || !state) {
      Segment.trackUserGot('DiscountLandingPage_UnknownError');
      DDLogs.error(
        'Got invalid redirect from Discount with missing parameters or unknown error',
        { query: this.$route.query },
      );
      this.isSuccess = false;
      this.isKnownError = false;
      this.loading = false;
    } else if (refreshed) {
      Segment.trackUserGot('DiscountLandingPage_UserRefreshedPage');
      this.isSuccess = true;
      this.loading = false;
    } else {
      Segment.trackUserGot('DiscountLandingPage_convertingAccessCode', { query: this.$route.query });
      this.isSuccess = true;
      try {
        // add query param so if user refreshes the page we'll know not to try to convert the accessCode again.
        const query = { ...this.$route.query, refreshed: 'true' };
        this.$router.replace({ query });
        DDLogs.log('DiscountLandingPage_convertingAccessCode', { query: this.$route.query });
        await DiscountApi.convertAccessCodeToToken(accessCode, state); // this call may take some time to finish
        if (this.isNewOnboarding) {
          this.redirectToNewOnboarding();
        }
        this.loading = false;
      } catch (e) {
        DDLogs.error('Failed to convert access code to token! Check discount-api logs', { query: this.$route.query });
        this.loading = false;
      }
    }
  },
  computed: {
    ...mapGetters('onboardingState', ['onboardingCompleted']),
    ...mapState('onboardingState', ['pageName']),
    isNewOnboarding() {
      return this.syncOnboarding && !this.onboardingCompleted;
    },
  },
  methods: {
    ...mapActions('onboardingState', ['fetchOnboardingState']),
    redirectToNewOnboarding() {
      router.push({ path: '/ob' });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../scss/mixins';

  #discount-lading {
    margin: 30px;
    text-align: center;

    .discount-message {
      color: $riseup_black;

      .success-icon {
        margin-top: 70px;
        margin-bottom: 50px;
      }

      .message-title {
        @include title;
        font-size: 26px;
        font-weight: bold;
        white-space: pre-line;
        line-height: 32px;
      }

      .message-text {
        margin-top: 12px;
        font-size: 16px;
        line-height: 24px;
        white-space: pre-wrap;

        .bold {
          font-weight: bold;
        }

      }

      .new-line {
        margin-top: 20px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/non-authenticated/discount-api/DiscountLandingPage.vue